import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputErrorComponent } from './input-error.component';
import { SharedModule } from 'src/app/shared/shared.module';



@NgModule({
  declarations: [InputErrorComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    InputErrorComponent
  ]
})
export class InputErrorModule { }
